export type { WelcomeGalaxyGlyph, WelcomeGalaxyGlyphs } from "#welcome-galaxy-glyphs-types";
export { WELCOME_GALAXY_GLYPH_BOX, WELCOME_GALAXY_GLYPHS } from "#welcome-galaxy-glyphs";
